import { TanStackDevtools } from '@tanstack/react-devtools';
import type { QueryClient } from '@tanstack/react-query';
import { createRootRouteWithContext, Outlet } from '@tanstack/react-router';
import { TanStackRouterDevtoolsPanel } from '@tanstack/react-router-devtools';

import { Toaster } from '@components/ui/toaster';
import { ThemeProvider } from '@contexts/theme.context';

import TanStackQueryDevtools from '../integrations/tanstack-query/devtools';

import '../styles.css';

interface MyRouterContext {
  auth: {
    isAuthenticated: boolean;
    session?: unknown;
  };
  queryClient: QueryClient;
}

export const Route = createRootRouteWithContext<MyRouterContext>()({
  component: RootComponent,
  notFoundComponent: () => <div>404 - Not Found</div>,
});

function RootComponent() {
  return (
    <ThemeProvider>
      <Outlet />
      <Toaster />
      <TanStackDevtools
        config={{
          openHotkey: ['ctrl-h'],
          position: 'bottom-left',
        }}
        plugins={[
          {
            name: 'Tanstack Router',
            render: <TanStackRouterDevtoolsPanel />,
          },
          TanStackQueryDevtools,
        ]}
      />
    </ThemeProvider>
  );
}
